import './admin-certificate-editor/index';
